import React from 'react';

const ArrowClosedIcon = () => (
	<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M6.48585 6.73919L1.69066 11.1942C0.706661 12.0668 -0.629821 10.8806 0.332152 10.0251L4.67572 5.99953L0.306451 1.92967C-0.589432 1.13547 0.79111 -0.0302628 1.69066 0.767346L6.49686 5.23259C7.11737 5.77115 7.22018 6.09837 6.48585 6.73919Z" fill="#9392AD" />
	</svg>
);

export default ArrowClosedIcon;
